import * as React from "react";
import { forwardRef } from "react";
const SvgBadgeClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.66665 1.27301L8.72665 0.333008L4.99998 4.05967L1.27331 0.333008L0.333313 1.27301L4.05998 4.99967L0.333313 8.72634L1.27331 9.66634L4.99998 5.93967L8.72665 9.66634L9.66665 8.72634L5.93998 4.99967L9.66665 1.27301Z", fill: "#6859B5" }));
const ForwardRef = forwardRef(SvgBadgeClose);
export default ForwardRef;
